import { Grid, Typography, Box } from "@mui/material";
import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

const RightFooter = () => {
  return (
    <Grid item xs={12} md={4}>
      <Box sx={{ textAlign: "right" }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: "#ffffff",
            mb: 2.5,
          }}
        >
          לב הארץ
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "flex-end",
            }}
          >
            <Typography variant="body1" sx={{ color: "#e3f2fd" }}>
              באקה אל גרביה כניסה דרומית{" "}
            </Typography>
            <LocationOnIcon sx={{ color: "#ffffff", fontSize: "1.2rem" }} />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "flex-end",
            }}
          >
            <Typography
              variant="body1"
              component="a"
              href="tel:052-8488123"
              sx={{
                textDecoration: "none",
                color: "#e3f2fd",
                "&:hover": { color: "#ffffff" },
              }}
            >
             050-839-2552{" "}
            </Typography>
            <PhoneIcon sx={{ color: "#ffffff", fontSize: "1.2rem" }} />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "flex-end",
            }}
          >
            <Typography
              variant="body1"
              component="a"
              href="mailto:support@lev-haaretz.co.il"
              sx={{
                textDecoration: "none",
                color: "#e3f2fd",
                "&:hover": { color: "#ffffff" },
              }}
            >
              support@lev-haaretz.co.il
            </Typography>
            <EmailIcon sx={{ color: "#ffffff", fontSize: "1.2rem" }} />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default RightFooter;
